import React from 'react';
import SpecBottomSheet from '../SpecBottomSheet/SpecBottomSheet';
import { ChevronRightIcon } from '../icons';
import './SpecActionSheet.css';

export interface ActionSheetItem {
  key: string;
  label: string;
  icon?: React.ReactNode;
  danger?: boolean;
  onClick?: () => void;
}

export interface SpecActionSheetProps {
  open: boolean;
  onClose: () => void;
  items: ActionSheetItem[];
  title?: string;
}

export default function SpecActionSheet({
  open,
  onClose,
  items,
  title,
}: SpecActionSheetProps) {
  const handleItemClick = (item: ActionSheetItem) => {
    item.onClick?.();
    onClose();
  };

  return (
    <SpecBottomSheet open={open} onClose={onClose} title={title}>
      <div className="action-sheet-items">
        {items.map((item) => (
          <button
            key={item.key}
            className={`action-sheet-item ${item.danger ? 'action-sheet-item-danger' : ''}`}
            onClick={() => handleItemClick(item)}
          >
            <span className="action-sheet-item-label">
              {item.icon && <span className="action-sheet-item-icon">{item.icon}</span>}
              {item.label}
            </span>
            <ChevronRightIcon size="l" tone="darkGrey" />
          </button>
        ))}
      </div>
    </SpecBottomSheet>
  );
}
